// extracted by mini-css-extract-plugin
module.exports = {"container":"AccordionButton_container__3ke9i","label":"AccordionButton_label__1c6Tt","secondary":"AccordionButton_secondary__3e6T1"};